import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { Content } from "@radix-ui/react-select";
import { riotProductSkinSelectContent } from "../skins/riot-product/select-content";
const StylableSelectContent = ({ children, ...props }) => (React.createElement(Content, { ...props }, children));
StylableSelectContent.defaultProps = {
    "data-testid": "SelectContent",
};
export const SelectContent = styled(StylableSelectContent) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkinSelectContent,
})}
`;
//# sourceMappingURL=SelectContent.js.map